const SORT_ORDER = {
  ASC: 1,
  DESC: -1,   
};
  
module.exports = {
  SORT_ORDER,
};